module.exports = __webpack_public_path__ + "static/FL4-18dc9652e6311595e5a08178e7362499.png";